import React from "react";
import SlideShow from '../components/slideshow/ProjectSixSlide' 

function ProjectSix(){
  const backgroundImage = 'url(../assets/images/361-kingsdale-slide.jpg)';

  const style = {
      backgroundImage,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
  };

  return (
 <div>
 
    <div className="project-slider">
        <div className="third-wrapper">
            
            <div className="frame">
            <div id="projectSlideImg" style={style}>
                <div className="img-fade"></div>
                </div>
                <div className="wrapper">
                    <div className="project-slide-des">
                        <h1>Willowdale</h1>
                        <p>361 Kingsdale Ave, North York.</p>
                    </div>
                </div>
            </div>     
        </div> 
    </div>
 
  
        <section className="project">
            <div className="divider-project">
                <div className="project-des">
                    <h2>Project Details</h2>
                    <p><strong>Lot:</strong> 40' x 135'</p>
                    <p><strong>Location:</strong> 361 Kingsdale Ave, North York.</p>
                    <p><strong>Status:</strong> Completed (Aug 2003 - May 2004)</p>
                    <p><strong>Architect:</strong> Bijan Jafari & Kamran Pak</p>
                    <p><strong>Interior:</strong> Kamran Pak & Nina Bazian</p>
                </div>

            </div>
        </section>
        
 
        <div className="project-leadership-img">
            <div className="img-construction">
                <img src="../assets/images/home-birds.png" alt="home construction"/>
            </div>   
        </div>
 
    <div className="wrapper">
      <section className="project-des-section">

        <h3>Project Description</h3>
        <p>Description</p>

      </section>
    </div>



  
    <div className="wrapper">
        <section className="project-section">

                <SlideShow/>
          
        </section>
    </div>


    </div>
  );
}

export default ProjectSix;